import { useClickOutside } from '@flippingbook/web.react-hooks/dist/useClickOutside';
import { useMountedState } from '@flippingbook/web.react-hooks/dist/useMountedState';
import { BaseButton } from '@flippingbook/web.react-kit/dist/BaseButton';
import cx from 'classnames';
import { useCallback, useMemo, useRef, useState } from 'react';

import { b, e } from './style.css';

export function HeaderDropdown(props: HeaderDropdown.Props) {
    const { children, button, onClose, onOpen, activityStyle = 'background' } = props;

    const thisRef = useRef<HTMLDivElement>(null);
    const [dropdownVisible, setDropdownVisible] = useState(false);
    const isMounted = useMountedState();

    const className = useMemo(
        () =>
            cx(b.name, {
                [b.m.activityUnderline]: activityStyle === 'underline',
                [b.m.activityBackground]: activityStyle === 'background',
                [b.m.opened]: dropdownVisible,
            }),
        [dropdownVisible, activityStyle],
    );

    const toggleDropdown = useCallback(() => {
        if (dropdownVisible) {
            onClose && onClose();
        } else {
            onOpen && onOpen();
        }
        isMounted() && setDropdownVisible(!dropdownVisible);
    }, [dropdownVisible, isMounted, onClose, onOpen]);

    const hideDropdown = useCallback(() => {
        onClose && onClose();
        isMounted() && setDropdownVisible(false);
    }, [isMounted, onClose]);

    useClickOutside(thisRef, hideDropdown);

    return (
        <div
            className={className}
            ref={thisRef}
        >
            <BaseButton
                className={e.dropdownToggler}
                onClick={toggleDropdown}
            >
                {button}
                <span className={e.iconArrowDown} />
            </BaseButton>
            <div
                className={e.dropdown}
                onClick={hideDropdown}
            >
                {children}
            </div>
        </div>
    );
}

export namespace HeaderDropdown {
    export interface Props {
        activityStyle?: 'underline' | 'background';
        button: React.ReactNode;
        children: React.ReactNode;
        onOpen?: () => void;
        onClose?: () => void;
    }
}
